<template>
  <b-modal
    id="signup-professional-modal"
    class="signup-professional-full-screen-modal"
    centered
    hide-header
    no-close-on-esc
    ok-variant="primary">

    <div>
      <div>
        <h1 class="page-title mb-4">{{$t('signup.professional.modal.title')}}</h1>
        <p class="signup-professional-text mt-2" v-html="$t('signup.professional.modal.content.one') + `<span style='color: white;'>${redirectConnexionUrl}</span>`"></p>
        <p class="signup-professional-text" v-html="$t('signup.professional.modal.content.two')"></p>
      </div>
    </div>


    <template #modal-footer="{ ok }">
      <div class="w-100 d-flex">
        <b-button  class="w-100 mr-2" variant="secondary"  @click="close">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('Close')}}</span>
          </div>
        </b-button>
        <b-button  class="w-100" variant="primary"  @click="handleOk($event)">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('signup.professional.modal.go')}}</span>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

export default {

  props:{
    redirectConnexionUrl: {
      default: ""
    },
  },

  methods: {

    handleOk(e) {
      e.preventDefault()
      window.open(this.redirectConnexionUrl, '_self')
    },

    close(){
      this.$bvModal.hide('signup-professional-modal')
    },

  },
};
</script>

<!-- not scoped car modal --><style>
#signup-professional-modal .modal-content,
#signup-professional-modal .modal-header,
#signup-professional-modal .modal-body,
#signup-professional-modal .modal-footer{
  background-color: var(--main-black-dark);
}

.signup-professional-text{
  color: var(--main-grey-medium);
}

#signup-professional-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.signup-professional-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.signup-professional-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #signup-professional-modal .modal-content {
    display: flex;
    overflow: auto;
  }

  #signup-professional-modal .modal-body{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #signup-professional-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #signup-professional-modal .modal-content {
    padding: 0;
    margin: 8px;
  }
}

@media (max-height: 852px) {
  #signup-professional-modal .modal-content {
    overflow: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/auth/SignupProfessionalModal.vue